import { CORNER_THICKNESS } from '@rta/rta-blueprint-library';

import { CursorMode } from '../enums';
import { DesignerOptionsData } from '@r-core/controller';
import { DimensionOrientationMode, ShowDimensions } from '@r-core/types';
import { renderLayerDefaults } from '@r-services/render-layers';
import { viewportDefaults } from '@r-services/viewport';
import { truncate } from 'node:fs';

export const designerOptionsDefaults: DesignerOptionsData = {
	cursorMode: CursorMode.Select,
	contextMenu: false,
	appliance: {
		showLabel: true,
		fontSizeFactor: 1
	},
	// url used to download component images
	assetsBaseUrl: '',
	assetsSasToken: '',
	useFractions: false,
	// cutout opacity, appliance opacity = 100 - (this)
	backgroundColor: '#EDF2F7',
	applianceOpacity: 0,
	cutoutOpacity: 0,
	borderColor: 'darkgrey',
	cutoutColor: 'white',
	dimensions: {
		fontSizeFactor: 1.25
	},
	dimensionFontSizeFactor: 1.2,
	// Corner
	corner: {
		show: true,
		thickness: CORNER_THICKNESS,
		width: 2.5
	},
	// performance tracking
	fps: {},
	// -- panel placement from the bottom of the coordinate space
	panelBottomPadding: 9,
	// default designer to read-only
	readonly: false,
	highlightFrontPanel: false,
	// hide or show inside/outside dimensions of component
	showAllDimensions: false,
	showBreakpoints: true,
	showAppliances: true,
	showApplianceDimensions: true,
	showCutouts: true,
	showCountertops: true,
	showCorners: true,
	showDimensions: true,
	showDimensionsMode: ShowDimensions.Outside,
	showDisplayMode: false,
	showHints: true,
	showIslandBaseDimensions: true,
	showOverheadDimensions: true,
	showOverlap: true,
	showObstructions: true,
	showBacksplashes: true,
	showPanelInsideDimensions: false,
	showPanelOutsideDimensions: true,
	showTitle: true,
	showState: true,
	showZoom: false,
	// Appliance Groups
	showApplianceGroups: false,
	showDeveloperInsights: false,
	// SKU Layer
	showSkuLayer: false,
	// Customer
	customerName: '',
	// Blueprint view metadata
	isBlueprintView: false,
	designerName: '',
	designerInitials: '',
	currentUserInitials: '',
	layoutDescription: '',
	creationDate: '',
	threeDImageUrl: '',
	dimensionOrientationMode: DimensionOrientationMode.Standard
	// // Render Layer Configuration - defaults from render layer system
	// renderLayerConfig: renderLayerDefaults,	// Coordinate System

	// // Viewport Configuration - centralized viewport settings
	// viewport: viewportDefaults
};
